<template>
	<div
		ref="markingZone"
		class="marking-zone"
		:class="{'is-active': markingActive}"
	>
		<div
			ref="mask"
			class="marking-zone__mask"
			:style="maskStyle"
		/>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	name:  'MarkingZone',
	props: {
		eventDuration: {
			type:     Number,
			required: true,
		},
		zoomLevel: {
			type: Number,
		},
		elapsed: {
			type: Number,
		},
	},
	computed: {
		...mapGetters({
			markingActive: 'markingZone/active',
			markingStart:  'markingZone/start',
		}),
		maskStyle() {
			const width = Math.max(this.endPosition - this.startPosition, 0);
			return {
				transform: `translateX(${this.startPosition}px)`,
				width:     `calc(${width}px + 2px)`,
			};
		},
		endPosition() {
			if (!this.markingActive) {
				return 0;
			}
			const zoneEl = this.$refs.markingZone;
			const position = (this.elapsed / this.eventDuration) * zoneEl.offsetWidth +
				(this.zoomLevel - this.zoomLevel); // hack to make it reactive to zoom level

			return position;
		},
		startPosition() {
			if (!this.markingActive) {
				return 0;
			}
			const zoneEl = this.$refs.markingZone;
			return (this.markingStart / this.eventDuration) * zoneEl.offsetWidth +
				(this.zoomLevel - this.zoomLevel); // hack to make it reactive to zoom level
		},
	},
	methods: {
		handleMarkOut() {
			const { duration, timestamp } = this.endMarking();
			if (!this.cutTag) {
				throw new Error('Unable to retrieve the `cut` tag from store.');
			}
			this.createCut(this.cutTag, timestamp, duration);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.marking-zone {
	position: relative;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	height: 100%;
	width: 100%;
}

.marking-zone__mask {
	.marking-zone.is-active & {
		z-index: 9; // below the needle (z-index: 10)
		position: absolute;
		left: 0;
		top: 0;
		height: 85px;
		width: 100%;
		border: 1px solid var(--color-red);
		opacity: 1;
		margin-top: 8px;
		border-radius: 4px;
	}
}
</style>
